import { jsx as _jsx } from "react/jsx-runtime";
import { useGenerateScriptPanelContext } from '@/hoc/context/generate-script-panel-context';
import { ScriptConfigurationPanel } from '../script-config';
import { ThemeConfigurationPanel } from '../theme-config';
export const GenerateScriptPanel = ({ children }) => {
    const { configuration, isThemePanelOpen, setConfiguration, setTheme, theme } = useGenerateScriptPanelContext();
    if (isThemePanelOpen) {
        return (_jsx(ThemeConfigurationPanel, { theme: theme, setTheme: setTheme, configuration: configuration, setConfiguration: setConfiguration, children: children }));
    }
    return (_jsx(ScriptConfigurationPanel, { configuration: configuration, setConfiguration: setConfiguration }));
};
